import { useMutation, useQueryClient } from "react-query";
import { RequestAccessForGroupData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useRequestAccessForWorkspaceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: RequestAccessForGroupData) =>
      workspaceService.requestAccessForGroup(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allGroups);
      },
    }
  );
};
